/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { constructLoginRoute } from './utils';

export const allRoles: Array<string> = ['Administrator', 'Editor', 'Contributor', 'Reader'];
export const adminRoles: Array<string> = ['Administrator', 'Editor'];

function hasPermissionsToNavigateToRoute(currentUserRole: string, allowedUserRoles: Array<string>): boolean {
  return allowedUserRoles.includes(currentUserRole);
}

export function behindFeatureFlag(store: any, featureFlag: string) {
  // eslint-disable-next-line no-unused-vars
  return (to, from, next) => {
    if (!store.getters.featureFlagState(featureFlag)) {
      // TODO redirect to 404 page
      next(false);
    } else {
      next();
    }
  };
}

export function canNavigateToRoute(store: any, allowedRoles: Array<string> = ['Administrator']) {
  // eslint-disable-next-line no-unused-vars
  return (to, from, next) => {
    const userRole = store.getters.currentUser.userRole.value;

    // This means that user is not even logged in
    if (!userRole) {
      // In this case redirect to login
      // this is sort of a hack since /login route does not exist
      // on vuejs routes
      window.location.href = constructLoginRoute(to.path);
    }

    if (!hasPermissionsToNavigateToRoute(userRole, allowedRoles)) {
      // TODO redirect to 404 page
      next(false);
    } else {
      next();
    }
  };
}

// TODO remove after page uses new sor listing
export function shouldRouteToOldSoRListing(store: any, path: string, next) {
  let shouldRouteToOldSor = false;

  if (path == '/sor/listing/events-log' && store.getters.featureFlagState('new_listing_event_logs') == false) {
    return next({ path: '/sor/listing/Revision' });
  }
  if (
    path == '/sor/listing/questionnaire-responses' &&
    store.getters.featureFlagState('new_listing_survey_responses') == false
  ) {
    return next({ path: '/sor/listing/SurveyResponse' });
  }
  if (path == '/sor/listing/tags' && store.getters.featureFlagState('new_listing_tags') == false) {
    return next({ path: '/sor/listing/TagInfo' });
  }

  switch (path) {
    case '/sor/listing/Revision':
      shouldRouteToOldSor = !store.getters.featureFlagState('new_listing_event_logs');
      break;
    case '/sor/listing/SurveyResponse':
      shouldRouteToOldSor = !store.getters.featureFlagState('new_listing_survey_responses');
      break;
    case 'sor/listing/TagInfo':
      shouldRouteToOldSor = !store.getters.featureFlagState('new_listing_tags');
      break;
    default:
      shouldRouteToOldSor = false;
  }
  return shouldRouteToOldSor;
}

export function canNavigateToNewSor(store: any) {
  /* This guard "refreshes" the page in case "sor_listing_v3" feature flag is disabled,
   * which causes the backend to handle the request (and exists the SPA context).
   */
  // eslint-disable-next-line no-unused-vars
  return (to, from, next) => {
    if (!store.getters.featureFlagState('sor_listing_v3') || shouldRouteToOldSoRListing(store, to.path, next)) {
      window.location.href = to.fullPath;
    } else {
      next();
    }
  };
}
